<tui-hosted-dropdown
    *tuiLet="isActive$ | async as active"
    #tableCommand
    [content]="tableOptionsDropdown"
    [canOpen]="!!active"
>
    <button
        tuiIconButton
        type="button"
        size="s"
        icon="tuiIconAddRowLarge"
        appearance="icon"
        tuiHintDirection="top-left"
        tuiHintDescribe
        [tuiHint]="rowsColumnsManagingText$ | async"
        [focusable]="tableCommand.open"
        [disabled]="!active"
    ></button>
</tui-hosted-dropdown>

<ng-template #tableOptionsDropdown>
    <tui-data-list>
        <tui-opt-group *ngFor="let group of tableCommandTexts$ | async; let i = index">
            <!-- TODO: remove "magic" numbers i*2+j and make code more readable-->
            <button
                *ngFor="let item of group; let j = index"
                tuiOption
                (click)="onTableOption(i * 2 + j)"
            >
                {{ item }}
            </button>
        </tui-opt-group>
    </tui-data-list>
</ng-template>
